import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface PageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  centered?: boolean;
  className?: string;
  /** Extra header content (meta lines, timestamps) rendered below the description. */
  children?: ReactNode;
}

export function PageHeader({ title, description, centered = false, className, children }: PageHeaderProps) {
  return (
    <div className={cn("space-y-4 print:space-y-2", centered && "text-center", className)}>
      <h1 className="text-4xl md:text-5xl font-bold tracking-tight print:text-2xl print:text-shadow-none">
        {title}
      </h1>
      {description && (
        <p
          className={cn(
            "text-lg text-muted-foreground max-w-2xl print:text-base print:text-foreground",
            centered && "mx-auto",
          )}
        >
          {description}
        </p>
      )}
      {children}
    </div>
  );
}
